import { Routes, Route } from "react-router-dom";
import { CampaignRouletteList } from "./list";
import { CreateCampaignRoulette } from "./create";
import { EditCampaignRoulette } from "./edit";

export default function CampaignRouletteRoutes() {
  return (
    <Routes>
      <Route path="/" element={<CampaignRouletteList />} />
      <Route path="/criar" element={<CreateCampaignRoulette />} />
      <Route path="/editar/:id" element={<EditCampaignRoulette />} />
    </Routes>
  );
}
